
let domain = "";
if(window.location.origin.includes("iatseg") ){
 domain = "iatseg.org"
}else if(window.location.origin.includes("ivyis")) {
 domain = "ivyis.org"
}else {
    domain = "localhost"
}

export   const  BASE_URL =domain == "localhost" ? "https://localhost/Capistone/backend" :  `https://student.${domain}/backend`;




